import React from "react";
import { InvoicePaymentFormProvider, useForm } from "./provider";
import { StripeSDKLoader } from "../../utils/StripeSdkLoader";
import { CardPaymentPage } from "./CardPaymentPage";
import { PickPaymentMethodPage } from "./PickPaymentMethodPage";
import { OfflinePaymentPage } from "./OfflinePaymentPage";
import { CreatePaymentMethodPage } from "./CreatePaymentMethodPage";
import { SuccessPage } from "./SuccessPage";
import StepWizard from "react-step-wizard";

const customAnimationClasses = {
  enterRight: '',
  enterLeft: '',
  exitRight: '',
  exitLeft: '',
  intro: ''
};

const PaymentHeader = () => {
  const { state } = useForm();
  const { member, chargeData } = state;

  return (
    <div className="px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-emerald-50 to-green-50">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-emerald-600 flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div>
            <h1 className="text-base font-semibold text-gray-900">Make Payment</h1>
            <p className="text-sm text-gray-500">for {member?.user?.first_name} {member?.user?.last_name}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs text-emerald-600 font-medium">Amount Due</p>
          <p className="text-xl font-bold text-emerald-700">${chargeData?.total || '0.00'}</p>
        </div>
      </div>
    </div>
  );
};

const InvoicePaymentFormPage = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <PaymentHeader />
      <StepWizard transitions={customAnimationClasses}>
        <PickPaymentMethodPage stepName={"pick_payment_method"} />
        <CreatePaymentMethodPage stepName={"create_payment_method_page"} />
        <CardPaymentPage stepName={"card_payment_page"} />
        <OfflinePaymentPage stepName={"offline_payment_page"} />
        <SuccessPage stepName={"success_page"} />
      </StepWizard>
    </div>
  );
};

const InvoicePaymentForm = (props) => {
  const { stripe_publishable_key } = props;
  return (
    <StripeSDKLoader stripe_publishable_key={stripe_publishable_key}>
      <InvoicePaymentFormProvider {...props}>
        <InvoicePaymentFormPage />
      </InvoicePaymentFormProvider>
    </StripeSDKLoader>
  );
};

export default InvoicePaymentForm;
